// toast.js
(function () {
  if (typeof window === 'undefined') return;

  const DEFAULTS = {
    addToCart: {
      successTitle: 'Item added successfully.',
      successMessage: 'Item added successfully.',
      errorTitle: 'Could not add to cart',
      errorMessage: 'Please try again.',
    },
    updateCart: {
      errorTitle: 'Could not update cart',
      errorMessage: 'Please try again.',
    },
    removeCart: {
      successTitle: 'Removed from cart',
      successMessage: 'Item has been removed.',
      errorTitle: 'Could not remove item',
      errorMessage: 'Please try again.',
    },
  };

  function isCartDrawerOpen() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return false;
    const contentEl = cartDrawer.querySelector('ck-drawer-content');
    const dialog = contentEl?.shadowRoot?.querySelector?.('dialog');
    return dialog && (dialog.hasAttribute('open') || dialog.getAttribute('data-status') === 'open');
  }

  // Store pending toast timer to allow cleanup
  let pendingToastTimer = null;

  function emitToast(variant, { title, description, closable = true, duration, product } = {}) {
    try {
      // Clean up any pending toast timer
      if (pendingToastTimer) {
        clearTimeout(pendingToastTimer);
        pendingToastTimer = null;
      }

      // If cart drawer is open, delay toast slightly to ensure it appears above
      const drawerOpen = isCartDrawerOpen();
      const delay = drawerOpen ? 100 : 0;

      pendingToastTimer = setTimeout(() => {
        pendingToastTimer = null;

        // Prefer typed helpers if you have them
        const fn = window.toast?.[variant];
        if (typeof fn === 'function') {
          fn({ title, description, closable, duration, product });
          return;
        }

        // Fallback to generic toast function
        if (typeof window.toast === 'function') {
          window.toast({ title, description, variant, closable, duration, product });
        }
      }, delay);
    } catch (e) {
      console.error('[toast] failed:', e);
      if (pendingToastTimer) {
        clearTimeout(pendingToastTimer);
        pendingToastTimer = null;
      }
    }
  }

  function normalizeShopifyError(err) {
    // err can be Error, string, or Shopify error JSON
    const message = err?.description || err?.message || (typeof err === 'string' ? err : '') || '';

    // Make common Shopify-ish messages friendlier
    const lower = message.toLowerCase();

    if (
      lower.includes('sold out') ||
      lower.includes('out of stock') ||
      lower.includes('not available')
    ) {
      return 'Not enough stock available for the quantity selected.';
    }

    if (lower.includes('cart') && lower.includes('validation')) {
      return 'We couldn’t add this item due to a cart validation issue. Please try again.';
    }

    return message || null;
  }

  // Expose a single API
  window.ckToast = {
    success(action, opts = {}) {
      const cfg = DEFAULTS[action] || {};

      console.log('[ckToast.success] Called with:', { action, opts });

      // Support product toast type
      // For product type toasts: title is the toast title, product.name is the product name
      const toastInput = {
        ...opts,
      };

      // If product info is provided, use product type toast
      if (opts.product) {
        console.log('[ckToast.success] Product detected, using product type toast:', opts.product);
        // Product type toasts: title is the toast title, product.name is the product name
        // For addToCart, title should be "Item added successfully."
        toastInput.title = opts.title || cfg.successTitle || 'Success';
        toastInput.product = opts.product;
        // Don't include description for product type toasts - it comes from product.description if available
      } else {
        // Default type toast: title and description are both used
        toastInput.title = opts.title || cfg.successTitle || 'Success';
        toastInput.description = opts.description || cfg.successMessage || '';
      }

      emitToast('success', toastInput);
    },

    error(action, err, opts = {}) {
      const cfg = DEFAULTS[action] || {};
      const friendly = normalizeShopifyError(err);

      // Always log details for devs
      if (opts.log !== false) {
        console.error(`[${action}]`, err);
      }

      // Support product toast type
      const toastInput = {
        variant: 'error', // Map 'danger' to 'error' for new variant system
        ...opts,
      };

      // If product info is provided, use product type toast
      if (opts.product) {
        // Product type toasts require a title (toast title, not product name)
        toastInput.title = opts.title || cfg.errorTitle || 'Something went wrong';
        toastInput.product = opts.product;
        // Don't include description for product type toasts - it comes from product.description if available
      } else {
        // Default type toast: title and description are both used
        toastInput.title = opts.title || cfg.errorTitle || 'Something went wrong';
        toastInput.description =
          opts.description || friendly || cfg.errorMessage || 'Please try again.';
      }

      emitToast('error', toastInput);
    },
  };
})();
